import { guidGenerator } from "../../../helpers/guid";
import { removeEmpty } from "../../../helpers/object";

export default class Submission {
  static newFromParams(params) {
    const props = removeEmpty({
      submittedAt: new Date(),
      id: params["id"],
      guid: params["guid"],
      email: params["email"],
      name: params["name"],
      memberOfferCode: params["member_offer_code"],
      memberTierCode: params["member_tier_code"],
    });
    return new Submission(props);
  }

  constructor(props = {}) {
    this.id = props.id;
    this.guid = props.guid || guidGenerator();
    this.submittedAt = getAsDate(props.submittedAt);
    this.acceptedAt = getAsDate(props.acceptedAt);
    this.email = props.email;
    this.name = props.name;
    this.memberOfferCode = props.memberOfferCode;
    this.memberTierCode = props.memberTierCode;
  }

  isAccepted() {
    return this.acceptedAt !== null && this.acceptedAt !== undefined;
  }

  // This takes in the JSON returned from the server which is a representation of the `MemberOfferAcceptance` Ruby object.
  updateFromServer(json) {
    this.id = json["id"];
    this.guid = json["guid"];
    this.acceptedAt = new Date(Date.parse(json["created_at"])); // Note that this uses the `created_at` field from the server for the `acceptedAt` field.
    this.email = json["email"];
    this.name = json["name"];
    this.memberOfferCode = json["member_offer_code"];
    this.memberTierCode = json["member_tier_code"];
  }
}

function getAsDate(value) {
  return value ? new Date(Date.parse(value)) : null;
}
